var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_368_2010",
    transform: "translate(-0.015625) scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_368_2010",
    width: 33,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAgCAYAAACcuBHKAAABqElEQVRYhcWW23HCMBBFD2kg7iCU4A6gBDoIHZAOQgnpIHQQSiAVJB0AFeBUkHxoDeuN1rZkMHdGM5b1OnttaQXD9Ab8AuuB82RrKgB1md4DYmMgNmMDWBfu4oZ1YXQ3rAtr7uCGdmEn73aM6IZ1YS7v54zoRsyFWjd1YwrMgFfiLtSybqxkXKcrE7XQE1AChUxYSD2mzwgEBDdmzphvoJI+ldSPwAHgnfh2aysxAPjvRp/yMZGHNv0IdR3JVp49lcCCi5Ml8NixxjkJ6bLEjzZXc5nXrnVOfi+m4YsQyTVVyLw22IYs5TVBegHcEiQJ4BYgWQDXBBkE4IGkXuFsdk0GqKXzQeokOgibZxp66JhIHzKHRAjdv/WwmrQ10jxNu/pmj29zQievo9OnICQs76fV47xk2AqhU7D9FAUhte8J33svdQujx2VddPTfrXfGCjjR/PPrcpL2rjl6S++MBfBMiLhPet5Lf71DtjkQesFY5Acu23Yp9ZgzGixZXpQV/pmxlHZvbJJiN6SK8F27ju9C+sVgku4oZcbifWDcbeppkbm4B+O68AdldATqzwyd0QAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.f16b2285e562e55e66f07a7f4286ccb9.svg";
export { ForwardRef as ReactComponent };